import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SpainFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14672'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14672)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 3.73333H20V0H0V3.73333Z'
					fill='#DD172C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14.0001H20V10.2667H0V14.0001Z'
					fill='#DD172C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 10.2666H20V3.73328H0V10.2666Z'
					fill='#FFD133'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M5.23828 6.53331H6.19066V6.99998H5.23828V6.53331Z'
					fill='#FFEDB1'
				/>
				<path
					d='M4.4405 6.76156C4.42396 6.56702 4.5774 6.39998 4.77264 6.39998H5.70206C5.8973 6.39998 6.05074 6.56703 6.0342 6.76156L5.93829 7.88945C5.90733 8.25355 5.60276 8.53332 5.23735 8.53332C4.87194 8.53332 4.56737 8.25355 4.53641 7.88945L4.4405 6.76156Z'
					stroke='#A41517'
					strokeWidth='0.666667'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.28516 7H6.18992V7.46667H5.71373L5.23754 8.4L4.76135 7.46667H4.28516V7Z'
					fill='#A41517'
				/>
				<rect
					x='2.85742'
					y='5.59998'
					width='0.952381'
					height='3.26667'
					rx='0.476191'
					fill='#A41517'
				/>
				<rect
					x='6.66602'
					y='5.59998'
					width='0.952381'
					height='3.26667'
					rx='0.476191'
					fill='#A41517'
				/>
				<path
					d='M4.28516 5.41329C4.28516 5.00092 4.61945 4.66663 5.03182 4.66663H5.44325C5.85562 4.66663 6.18992 5.00092 6.18992 5.41329C6.18992 5.51639 6.10634 5.59996 6.00325 5.59996H4.47182C4.36873 5.59996 4.28516 5.51639 4.28516 5.41329Z'
					fill='#A41517'
				/>
			</g>
		</svg>
	);
};

export default SpainFlagIcon;
